import React from 'react';
import {
  IllustrationIcon,
  IllustrationMode,
  IllustrationSize,
  InfoBox,
  InfoBoxVariant,
  Scale,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useTranslations } from '@utils/useTranslations';
import { getTranslationKeys } from './AssistedSaleBanner.utils';

interface AssistedSaleBannerProps {
  isFamilyVariant: boolean;
  isMobile: boolean;
}

export const AssistedSaleBanner = ({ isFamilyVariant, isMobile }: AssistedSaleBannerProps) => {
  const { translations } = useTranslations();

  const { titleKey, subtitleKey } = getTranslationKeys({ isFamilyVariant, isMobile });

  const illustrationConfig = !isMobile
    ? { icon: IllustrationIcon.Social, mode: IllustrationMode.light, size: IllustrationSize.xs }
    : undefined;

  return (
    <InfoBox
      title={i18n(titleKey, [], translations)}
      subTitle={i18n(subtitleKey, [], translations)}
      variant={InfoBoxVariant.safety}
      borderConfig={{
        radius: Scale.xxs,
        showLeftLip: false,
      }}
      illustrationConfig={illustrationConfig}
      dataAttributes={{ testid: 'assisted-sale-banner' }}
    />
  );
};
